export const termsAndConditionsLink = 'https://cast-soft.com/cast/files/Terms-Conditions.pdf';
// export const EDU_TEACHER_ELIGIBILITY_LINK = 'https://cast-soft.com/teachers/#terms';
export const EDU_TEACHER_ELIGIBILITY_LINK = 'https://cast-soft.com/educational-program/wysiwyg-educational-program/';
// export const EDU_STUDENT_ELIGIBILITY_LINK = 'https://cast-soft.com/students/#terms';
export const EDU_STUDENT_ELIGIBILITY_LINK = 'https://cast-soft.com/educational-program/wysiwyg-educational-program/';
